<div class="login-Wrapper">
  <div class="login login-card">
    <div class="d-flex justify-content-between login-header">
      <h3 class="login-header-type">
        <img
          src="../../../assets/images/login/header-type-user.png"
          alt=""
          class="icon"
        />
        <!-- <img src="/assets/images/login/header-type-company.png" alt=""> -->

        {{
          signupType === "COMPANY"
            ? ("Register as a company" | translate)
            : ("Register as a member" | translate)
        }}
        <!-- التسجيل كشركة تنظيم -->
      </h3>

      <a [routerLink]="['../signup-type']" class="login-header-backLink">
        <img
          src="../../../assets/images/login/header-back-btn.png"
          alt=""
          class="icon"
        />
        {{ "Go back" | translate }}
      </a>
    </div>
    <form [formGroup]="signupForm" (ngSubmit)="signup()">
      <div class="login-body">
        <div class="form-group">
          <app-evento-input
            [eventoFormControl]="signupForm.get('firstName')"
            type="text"
            requiredMessage="{{ 'Required Field' | translate }}"
            minlengthMessage="{{
              'Min Length Field' | translate : { value: '2' }
            }}"
            maxlengthMessage="{{
              'Max Length Field' | translate : { value: '30' }
            }}"
            placeholder="{{ 'First Name' | translate }}"
            invalidCharsMessage="{{
              'Only Arabic and English letters are allowed' | translate
            }}"
          ></app-evento-input>
        </div>
        <div class="form-group">
          <app-evento-input
            [eventoFormControl]="signupForm.get('lastName')"
            type="text"
            requiredMessage="{{ 'Required Field' | translate }}"
            minlengthMessage="{{
              'Min Length Field' | translate : { value: '2' }
            }}"
            maxlengthMessage="{{
              'Max Length Field' | translate : { value: '30' }
            }}"
            placeholder="{{ 'Last Name' | translate }}"
            invalidCharsMessage="{{
              'Only Arabic and English letters are allowed' | translate
            }}"
          >
          </app-evento-input>
        </div>
        <div class="form-group">
          <app-evento-input
            [eventoFormControl]="signupForm.get('email')"
            requiredMessage="{{ 'Required Field' | translate }}"
            patternMessage="{{ 'Valid Email Address' | translate }}"
            placeholder="{{ 'Email' | translate }}"
          >
          </app-evento-input>
        </div>
        <div class="form-group">
          <app-evento-input
            [eventoFormControl]="signupForm.get('mobile')"
            type="mobile"
            [country]="signupForm?.value?.mobileRegionCode"
            requiredMessage="{{ 'Required Field' | translate }}"
            validatePhoneNumberMessage="{{ 'Valid Mobile Number' | translate }}"
          ></app-evento-input>
        </div>

        <div class="form-group">
          <app-evento-input
            [eventoFormControl]="signupForm.get('password')"
            type="password"
            minlengthMessage="{{
              'Min Length Field' | translate : { value: '6' }
            }}"
            requiredMessage="{{ 'Required Field' | translate }}"
            placeholder="{{ 'Password' | translate }}"
          ></app-evento-input>
        </div>
        <div class="form-group">
          <app-evento-input
            [eventoFormControl]="signupForm.get('confirmPassword')"
            type="password"
            minlengthMessage="{{
              'Min Length Field' | translate : { value: '6' }
            }}"
            requiredMessage="{{ 'Required Field' | translate }}"
            mustMatchMessage="{{ 'Not Matched' | translate }}"
            placeholder="{{ 'Confirm Password' | translate }}"
          ></app-evento-input>
        </div>
        <ng-container *ngIf="signupType === 'COMPANY'">
          <!--  company get(## START ##) -->
          <label for="">
            {{ "Organizer data" | translate }}
          </label>
          <div class="form-group">
            <app-evento-input
              [eventoFormControl]="signupForm.get('commercialName')"
              type="text"
              requiredMessage="{{ 'Required Field' | translate }}"
              minlengthMessage="{{
                'Min Length Field' | translate : { value: '2' }
              }}"
              maxlengthMessage="{{
                'Max Length Field' | translate : { value: '30' }
              }}"
              placeholder="{{ 'Company Name' | translate }}"
            ></app-evento-input>
          </div>
          <div class="form-group">
            <app-evento-input
              [eventoFormControl]="signupForm.get('address')"
              type="text"
              requiredMessage="{{ 'Required Field' | translate }}"
              placeholder="{{ 'Company Address' | translate }}"
            ></app-evento-input>
          </div>
          <div class="form-group">
            <app-evento-select
              [eventoFormControl]="signupForm.get('region')"
              placeholder="{{ 'Choose Region' | translate }}"
              [items]="regions$ | async"
              [multiple]="false"
            >
            </app-evento-select>
          </div>
          <div class="form-group">
            <app-evento-select
              [eventoFormControl]="signupForm.get('city')"
              placeholder="{{ 'Choose the city' | translate }}"
              [items]="cities$ | async"
              [multiple]="false"
              [disabled]="!!signupForm.get('region').value"
            >
            </app-evento-select>
          </div>

          <!--  company get(## END ##) -->
        </ng-container>

        <div class="form-group">
          <label class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              (change)="toggleAgree($event)"
            />
            <span class="custom-control-label">
              {{ "Agree to the" | translate }}
              <a
                href="#"
                (click)="
                  $event.preventDefault(); openLinkInNewWindow('/policy')
                "
                >{{ "Terms and Conditions" | translate }}</a
              >
            </span>
          </label>
        </div>
      </div>
    </form>
  </div>
  <div class="login pt-3">
    <button
      type="button"
      [disabled]="!isAgree || !signupForm.valid"
      (click)="signup()"
      class="btn btn-primary w-100 mb-3"
    >
      {{ "signUp" | translate }}
    </button>
  </div>
</div>
